import back from "../christmas/BANNER_2.webp";
import "./festive.scss";
import Nav from "./Nav";
import Footer from "./Footer";
export default function Festive() {
    return (
        <main>
            <Nav />
        <section className="xmas">
            <img id="backImage" src={back} alt="Festive banner" />
            {/* <div style={{position:"absolute", top:0}}> */}
            <section className="hero_section">
                
                <h1>Festive Opening Hours</h1>

                <h1>Christmas & New Year 2025/2026</h1>

                <h5>During the festive period, some stores may open with different hours!</h5>
                    
            </section>
            {/* <h3>FESTIVE OPENING HOURS</h3> */}
            <div className="xmasInfo">
                <div className="indivSite">
                    <p className="store__name">IBROX</p>
                    <p>X-MAS EVE (24/12/2025) :<span>5.30AM-11PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span>10AM-10PM</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>9AM-11PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>5.30AM-11PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span>10AM-10PM</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>5.30AM-11PM</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">BEARSDEN</p>
                    <p>X-MAS EVE (24/12/2025) :<span>7AM-10PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span>10AM-8PM</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>10AM-10PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>7AM-10PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span>10AM-10PM</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>9AM-10PM</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">STRATHCLYDE</p>
                    <p>X-MAS EVE (24/12/2025) :<span>7AM-10PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span style={{ color: "red", fontWeight: "700", textShadow: "1px 1px 2px gray" }}>CLOSED</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>9AM-10PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>7AM-10PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span style={{ color: "red", fontWeight: "700", textShadow: "1px 1px 2px gray" }}>CLOSED</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>9AM-10PM</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">CROW WOOD</p>
                    <p>X-MAS EVE (24/12/2025) :<span>7AM-10PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span>10AM-10PM</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>9AM-10PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>7AM-10PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span>10AM-10PM</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>9AM-10PM</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">BRAESIDE</p>
                    <p>X-MAS EVE (24/12/2025) :<span>24/7</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span>24/7</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>24/7</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>24/7</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span>24/7</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>24/7</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">RUTHERGLEN</p>
                    <p>X-MAS EVE (24/12/2025) :<span>6.15AM-10PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span>10AM-8PM</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>10AM-10PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>6.15AM-10PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span>10AM-8PM</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>10AM-10PM</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">DUMBARTON ROAD</p>
                    <p>X-MAS EVE (24/12/2025) :<span>7AM-10PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span>10AM-8PM</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>9AM-10PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>7AM-10PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span>12PM-8PM</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>9AM-10PM</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">BRIDGETON</p>
                    <p>X-MAS EVE (24/12/2025) :<span>7AM-9PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span style={{ color: "red", fontWeight: "700", textShadow: "1px 1px 2px gray" }}>CLOSED</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>10AM-6PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>7AM-9PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span style={{ color: "red", fontWeight: "700", textShadow: "1px 1px 2px gray" }}>CLOSED</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>10AM-8PM</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">SAUCHIEHALL</p>
                    <p>X-MAS EVE (24/12/2025) :<span>7AM-10PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span style={{ color: "red", fontWeight: "700", textShadow: "1px 1px 2px gray" }}>CLOSED</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>9AM-10PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>7AM-10PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span style={{ color: "red", fontWeight: "700", textShadow: "1px 1px 2px gray" }}>CLOSED</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>9AM-10PM</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">COATBRIDGE</p>
                    <p>X-MAS EVE (24/12/2025) :<span>8AM-10PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span style={{ color: "red", fontWeight: "700", textShadow: "1px 1px 2px gray" }}>CLOSED</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>10AM-10PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>8AM-10PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span style={{ color: "red", fontWeight: "700", textShadow: "1px 1px 2px gray" }}>CLOSED</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>10AM-10PM</span></p>
                </div>
                <div className="indivSite">
                    <p className="store__name">WISHAW</p>
                    <p>X-MAS EVE (24/12/2025) :<span>7AM-10PM</span></p>
                    <p>X-MAS DAY (25/12/2025) :<span style={{ color: "red", fontWeight: "700", textShadow: "1px 1px 2px gray" }}>CLOSED</span></p>
                    <p>BOXING DAY (26/12/2025) :<span>10AM-10PM</span></p>
                    <p>NEW YEARS EVE (31/12/2025) :<span>7AM-10PM</span></p>
                    <p>NEW YEARS DAY (01/01/2026) :<span>10AM-8PM</span></p>
                    <p>JAN 2ND (02/01/2026) :<span>10AM-10PM</span></p>
                </div>
            </div>


        </section>
        <Footer/>
        </main>
    );
}
